import { sectionNames } from "@saleor/intl";
import { asSortParams } from "@saleor/utils/sort";
import { parseQueryString } from "@saleor/utils/urls";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation, useParams } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import {
  WarehouseListUrlQueryParams,
  WarehouseListUrlSortField,
  WarehouseUrlQueryParams
} from "./urls";
import WarehouseCreate from "./views/WarehouseCreate";
import WarehouseDetailsComponent from "./views/WarehouseDetails";
import WarehouseListComponent from "./views/WarehouseList";

const WarehouseList: React.FC = () => {
  const location = useLocation();
  const qs = parseQs(location.search.substr(1));
  const params = asSortParams(
    qs,
    WarehouseListUrlSortField
  ) as WarehouseListUrlQueryParams;

  return <WarehouseListComponent params={params} />;
};

const WarehouseDetails: React.FC = () => {
  const location = useLocation();
  const { id } = useParams();
  const params = parseQueryString<WarehouseUrlQueryParams>(
    location.search.substr(1)
  );
  return (
    <WarehouseDetailsComponent id={decodeURIComponent(id)} params={params} />
  );
};

export const WarehouseSection: React.FC = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.warehouses)} />
      <Routes>
        <Route path={""} element={<WarehouseList />} />
        <Route path={"add"} element={<WarehouseCreate />} />
        <Route path={":id"} element={<WarehouseDetails />} />
      </Routes>
    </>
  );
};
export default WarehouseSection;
